import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { ComingSoon } from "@/components/marketing/ComingSoon";

export const Route = createFileRoute("/brand")({
  component: BrandPage,
});

function BrandPage() {
  return (
    <>
      <Helmet>
        {/*
          Noindexed while this is a placeholder. The page returns 200 and has a
          self-canonical, so without this it is indexable - and a "coming soon"
          stub in search results is worse than no result. Remove when the page
          has real content. The VITE_SHOW_* flag only hides it from the nav; it
          does not stop a crawler reaching it.
        */}
        <meta name="robots" content="noindex,follow" />
        <title>Brand | Larasoft</title>
        <meta
          name="description"
          content="Larasoft brand guidelines and resources."
        />
        <link rel="canonical" href="https://larasoft.global/brand" />
      </Helmet>
      <ComingSoon pageName="Brand" />
    </>
  );
}
